/*
 * Masterclass template helpers. Loaded by the masterclass sections / main-product custom Liquid block.
 * - "Join" links return to the one enrollment form (#masterclass-enroll) instead of submitting a second form.
 * - Keeps the hidden selling_plan fallback from overriding the subscription app's own control.
 * - Keeps the plan price / billing note in step with the selected selling plan.
 * - Hides a "next session" that ended after the page was cached (epoch comparison only, no local-time maths).
 * - Opens the collapsed review list when a review link or the rating badge is used.
 * - Shows the mobile enrollment bar.
 * Safe to load more than once and re-initialises on theme-editor section reloads.
 */
(function () {
  if (window.MasterclassTemplate) return;

  var ENROLL_ID = 'masterclass-enroll';
  var bars = new Map();

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function enrollForm(anchor) {
    return anchor && anchor.dataset.formId ? document.getElementById(anchor.dataset.formId) : null;
  }

  /* ---------- Enrollment links ---------- */

  function goToEnroll() {
    var anchor = document.getElementById(ENROLL_ID);
    if (!anchor) return false;
    var form = enrollForm(anchor);
    var focusEl = null;
    if (form) {
      focusEl =
        form.querySelector('input[name="selling_plan"]:checked:not([type="hidden"]):not([disabled])') ||
        form.querySelector('[type="submit"]:not([disabled])');
    }
    (focusEl || anchor).focus({ preventScroll: true });
    anchor.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'start' });
    return true;
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href="#' + ENROLL_ID + '"], [data-mc-enroll-link]');
    if (!link) return;
    if (goToEnroll()) event.preventDefault();
  });

  /* ---------- Submit button label ---------- */

  function applySubmitLabel() {
    var anchor = document.getElementById(ENROLL_ID);
    var label = anchor && anchor.dataset.submitLabel;
    var form = enrollForm(anchor);
    var button = form ? form.querySelector('[type="submit"]') : null;
    if (!label || !button || button.disabled) return;
    var text = button.querySelector('span') || button;
    if (text.textContent.trim() !== label) text.textContent = label;
  }

  /* ---------- Selling-plan fallback ---------- */

  function syncFallback(input) {
    var form = input.form;
    if (!form) return;
    var others = Array.prototype.filter.call(form.elements, function (el) {
      return el !== input && el.name === 'selling_plan';
    });
    input.disabled = others.length > 0;
  }

  function initFallbacks(root) {
    root.querySelectorAll('[data-mc-plan-fallback]').forEach(function (input) {
      if (input._mcObserver) return;
      syncFallback(input);
      if (!input.form) return;
      input._mcObserver = new MutationObserver(function () {
        syncFallback(input);
      });
      input._mcObserver.observe(input.form, { childList: true, subtree: true });
    });
  }

  /* ---------- Price / note follow the selected plan ---------- */

  function fill(template, values) {
    return Object.keys(values).reduce(function (text, key) {
      return text.split('[' + key + ']').join(values[key]);
    }, template || '');
  }

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || input.name !== 'selling_plan' || input.hasAttribute('data-mc-plan-fallback')) return;
    if (input.type === 'radio' && !input.checked) return;
    var dataEl = document.querySelector('script[data-mc-plans]');
    if (!dataEl) return;
    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    var plan = input.value ? data.plans[input.value] : null;

    document.querySelectorAll('.mc-price').forEach(function (block) {
      var amount = block.querySelector('[data-mc-price]');
      var interval = block.querySelector('[data-mc-interval]');
      var name = block.querySelector('[data-mc-plan-name]');
      if (amount) amount.textContent = plan ? plan.price : data.oneTimePrice;
      if (interval) interval.hidden = !(plan && plan.intervalOk);
      if (name) {
        name.textContent = plan ? plan.name : '';
        name.hidden = !plan || plan.intervalOk;
      }
    });

    document.querySelectorAll('[data-mc-recurring]').forEach(function (note) {
      note.hidden = !plan;
      if (!plan) return;
      var text = note.querySelector('[data-mc-recurring-text]');
      var template = plan.intervalOk ? note.dataset.template : note.dataset.fallbackTemplate;
      if (text) text.textContent = fill(template, { price: plan.price, interval: data.interval, plan: plan.name });
    });
  });

  /* ---------- Next session expiry (cached pages) ---------- */

  function checkSessions(root) {
    if (window.Shopify && window.Shopify.designMode) return;
    var now = Date.now() / 1000;
    root.querySelectorAll('[data-mc-session-end]').forEach(function (el) {
      var end = Number(el.dataset.mcSessionEnd);
      if (end > 0 && now > end) el.hidden = true;
    });
  }

  /* ---------- Reviews disclosure ---------- */

  function openReviews(target) {
    var details = target ? target.closest('details[data-mc-reviews-details]') : null;
    if (details && !details.open) details.open = true;
  }

  function openReviewsForHash(hash) {
    if (!hash || hash.length < 2) return;
    var target = null;
    try {
      target = document.getElementById(decodeURIComponent(hash.slice(1)));
    } catch (e) {
      return;
    }
    openReviews(target);
  }

  document.addEventListener(
    'click',
    function (event) {
      var link = event.target.closest('a[href*="#"]');
      if (link && link.hash && link.pathname === window.location.pathname) openReviewsForHash(link.hash);
      if (event.target.closest('.jdgm-prev-badge, [data-mc-open-reviews]')) {
        document.querySelectorAll('details[data-mc-reviews-details]').forEach(function (d) {
          d.open = true;
        });
      }
    },
    true
  );

  window.addEventListener('hashchange', function () {
    openReviewsForHash(window.location.hash);
  });

  /* ---------- Mobile enrollment bar ---------- */

  function destroyBar(section) {
    var entry = bars.get(section);
    if (!entry) return;
    window.removeEventListener('scroll', entry.onScroll);
    window.removeEventListener('resize', entry.onScroll);
    entry.bar.hidden = true;
    bars.delete(section);
  }

  function initBar(section) {
    destroyBar(section);
    var bar = section.querySelector('[data-mc-bar]');
    if (!bar) return;

    // Elements are looked up on every check: the theme and apps can re-render the product form after
    // load, so a reference cached at init time may be detached (its rect reads as 0,0).
    function currentSubmit() {
      var form = enrollForm(document.getElementById(ENROLL_ID));
      return form ? form.querySelector('[type="submit"]') : null;
    }

    // Position check on scroll/resize (browsers already fire scroll at most once per frame; three rect
    // reads). Unlike IntersectionObserver this also catches jump scrolls (anchor links, fast flicks)
    // where the button never intersects on its way past.
    function update() {
      var submit = currentSubmit();
      var footer = document.querySelector('footer');
      var vh = window.innerHeight;
      var submitAbove = submit ? submit.getBoundingClientRect().bottom < 0 : false;
      var ctaRect = section.getBoundingClientRect();
      var ctaVisible = ctaRect.top < vh && ctaRect.bottom > 0;
      var footerVisible = footer ? footer.getBoundingClientRect().top < vh : false;
      var show = submitAbove && !ctaVisible && !footerVisible;
      if (bar.hidden === show) bar.hidden = !show;
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    bars.set(section, { onScroll: update, bar: bar });
    update();
  }

  function initBars() {
    Array.from(bars.keys()).forEach(destroyBar);
    document.querySelectorAll('[data-mc-cta]').forEach(initBar);
  }

  /* ---------- Init + theme editor ---------- */

  function init(root) {
    applySubmitLabel();
    initFallbacks(root);
    checkSessions(root);
    initBars();
    openReviewsForHash(window.location.hash);
  }

  function cleanup(root) {
    root.querySelectorAll('[data-mc-plan-fallback]').forEach(function (input) {
      if (input._mcObserver) input._mcObserver.disconnect();
      input._mcObserver = null;
    });
    root.querySelectorAll('[data-mc-cta]').forEach(destroyBar);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    cleanup(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  window.MasterclassTemplate = { goToEnroll: goToEnroll };
})();
